/* eslint-disable import/prefer-default-export */
import Env from '../services/environment';

const EnvVars = Env.vars();

export const API_URL = {
  PWL1: `${EnvVars.API_URL}/sdk/pwl/signup`,
  PWL2: `${EnvVars.API_URL}/sdk/pwl/availability/email`,
  PWL3: `${EnvVars.API_URL}/sdk/pwl/availability/phone-number`,
  PWL4: `${EnvVars.API_URL}/sdk/pwl/reverify`,
  SINGPASS_INIT: `${EnvVars.API_URL}/sdk/singpass/init`,
};
